import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CartItemContextSource, CartSharedModule } from '@spartacus/cart/base/components'
import { CmsConfig, ConfigModule, I18nModule, UrlModule, provideConfig } from '@spartacus/core'
import { CardModule, IconModule, OutletModule, PromotionsModule } from '@spartacus/storefront'
import { translationOverwrites } from '../../../../../public/asaleocare.translate'
import { CustomCartSharedModule } from '../../cart/cart-shared/custom-cart-shared.module'
import { CustomCardModule } from '../../shared/card/card.module'
import { SharedModule } from '../../shared/shared.module'
import { CustomReviewSubmitComponent } from './custom-review-submit.component'

@NgModule({
  declarations: [CustomReviewSubmitComponent],
  imports: [
    CommonModule,
    CardModule,
    CartSharedModule,
    I18nModule,
    UrlModule,
    RouterModule,
    PromotionsModule,
    IconModule,
    SharedModule,
    CustomCartSharedModule,
    OutletModule,
    ConfigModule.withConfig({
      i18n: { resources: translationOverwrites }
    }),
    CustomCardModule
    // CustomCardModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutReviewOrder: {
          component: CustomReviewSubmitComponent
          // guards: [CheckoutAuthGuard, CartNotEmptyGuard, UserPermissionsGuard],
        }
      }
    }),
    CartItemContextSource
  ],
  exports: [CustomReviewSubmitComponent]
})
export class CustomReviewSubmitModule {}
